<template>
  <div>
    <v-card class="mb-2">
      <v-list-item-subtitle>{{ directionText }}</v-list-item-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <vuetify-google-autocomplete
              ref="addressAutocomplete"
              id="map"
              name="map"
              label="Address"
              append-icon="mdi-magnify"
              placeholder="Search for address"
              v-on:placechanged="getAddressData"
              v-model="formattedAddress"
              :country="limitToCountries"
              required>
              <template v-slot:append>
                <v-btn icon color="primary" v-on:click="clearAddress">
                  <v-icon>mdi-eraser</v-icon>
                </v-btn>
              </template>
            </vuetify-google-autocomplete>
            <validation-provider
              :rules="{ required: { allowFalse: false } }"
              v-slot="{errors}"
              name="Selected address">
              <div class="selected-address">
                <v-switch
                  id="selectedAddress"
                  class="ma-0 pa-0"
                  dense
                  text-caption
                  v-model="addressValid"
                  :color="addressValid ? 'green' : 'red'"
                  :error-messages="errors"
                  :readonly="true"
                  v-if="formattedAddress">
                  <template v-slot:label>
                    <v-alert
                      dense
                      class="ma-0"
                      :type="addressValid ? 'success' : 'error'">
                      <span v-if="addressValid">The selected address is serviced.</span>
                      <span v-if="!streetNumber">
                        Please enter a street number.
                      </span>
                      <div v-if="!addressValid">
                        The selected address is not serviced. Please call the office on:
                        <v-btn
                          class="white--text"
                          color="primary"
                          @click.native="callOffice()">
                          <v-icon left>mdi-cellphone</v-icon> 02 9997 7767
                        </v-btn>
                      </div>
                    </v-alert>
                  </template>
                </v-switch>
              </div>
            </validation-provider>
            <span v-if="exclusiveCharter">
              <div class="text-caption" v-if="maxAddresses > 0">
                You can add {{maxAddresses}} more {{maxAddresses > 1 ? "addresses" : "address"}}.
              </div>

              <template v-for="(item, index) in otherAddresses">
                <vuetify-google-autocomplete
                  v-bind:key="index"
                  :ref="`addressAutocomplete_${index}`"
                  :id="`additionalAddresses_${index}`"
                  :name="`additionalAddresses_${index}`"
                  label="Address"
                  append-icon="mdi-magnify"
                  placeholder="Search for address"
                  v-on:placechanged="getAdditionalAddress"
                  v-model="item.formattedAddress"
                  :country="limitToCountries"
                  required>
                  <template v-slot:append>
                    <v-btn icon color="primary" v-on:click="clearOtherAddress(index)">
                      <v-icon>mdi-eraser</v-icon>
                    </v-btn>
                  </template>
                </vuetify-google-autocomplete>
                <validation-provider
                  v-bind:key="`otherAddressMessage_${index}`"
                  :rules="{ required: { allowFalse: false } }"
                  v-slot="{errors}"
                  name="Selected other address">
                  <div class="selected-address">
                    <v-switch
                      :id="`otherAddressMessage_${index}`"
                      class="ma-0 pa-0"
                      dense
                      text-caption
                      v-model="item.isValid"
                      :color="item.isValid ? 'green' : 'red'"
                      :error-messages="errors"
                      :readonly="true"
                      v-if="item.formattedAddress">
                      <template v-slot:label>
                        <v-alert
                          dense
                          class="ma-0"
                          :type="item.isValid ? 'success' : 'error'">
                          <span v-if="item.isValid">The selected address is serviced.</span>
                          <div v-if="!item.isValid">
                            The selected address is not serviced. Please call the office on:
                            <v-btn
                              class="white--text"
                              color="primary"
                              @click.native="callOffice()">
                              <v-icon left>mdi-cellphone</v-icon> 02 9997 7767
                            </v-btn>
                          </div>
                        </v-alert>
                      </template>
                    </v-switch>
                  </div>
                </validation-provider>
              </template>

              <v-btn
                v-if="maxAddresses > 0"
                color="primary"
                class="float-left"
                @click="addAdditionalAddress()">Add Address</v-btn>
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-alert
          dense
          outlined
          type="warning">
            PLEASE ENTER YOUR CORRECT FLIGHT DETAILS,
            INCORRECT DETAILS MAY RESULT IN FAILURE TO COLLECT.
          </v-alert>
        </v-row>
        <template v-if="this.direction === 1 || this.direction === 3">
          <!-- To Airport or Return / Pickup / Departing Flight -->
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <validation-provider
                    name="Departure date"
                    :rules="'required'"
                    v-slot="{errors}" slim>
                    <v-text-field
                      v-model="fmtPickUpDetailsTravelDate"
                      label="Departure date"
                      prepend-icon="mdi-calendar"
                      readonly
                      :error-messages="errors"
                      v-on="on">
                    </v-text-field>
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="pickUpDetailsTravelDate"
                  @input="menu1 = false"
                  :min="getMinimumbookingDate()"
                  :allowed-dates="enableBookingDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                rules="required"
                name="Departing flight"
                v-slot="{ errors }">
                <v-autocomplete
                  v-model="pickUpDetailsDepartingFlight"
                  :items="CONFIGURATION.departingFlights"
                  :hint="DEPARTING_FLIGHT_HINT_TEXT"
                  persistent-hint
                  @change="onDepartingFlightChanged"
                  item-text="number"
                  item-value="id"
                  cache-items
                  flat
                  clearable
                  :error-messages="errors"
                  label="Departing flight">
                  <template v-slot:item="data">
                    {{ data.item.number }} -
                    {{ $moment(data.item.time, "HH:mm:ss").format(DISPLAY_TIME_FORMAT) }}
                  </template>
                  <template v-slot:no-data>
                    <template v-if="IS_ADMINISTRATOR">
                      <v-btn
                        color="orange darken-4"
                        dark
                        @click="addFlightDialog=true">
                        No data, Add flight
                      </v-btn>
                    </template>
                    <template v-if="!IS_ADMINISTRATOR">
                      <span class="pa-3">No matching flight found </span>
                    </template>
                   </template>
                </v-autocomplete>
                <add-flight v-model="addFlightDialog"></add-flight>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                rules="required"
                name="Pick-up time from address"
                v-slot="{ errors }">
                <v-select
                  id="pickupTime"
                  :items="PICKUP_TIMES"
                  :error-messages="errors"
                  item-text="formatted"
                  item-value="from"
                  v-model="pickUpDetailsPickupTime"
                  label="Pick-up time from address"
                  required
                  dense>
                   <template v-slot:item="{ item }">
                     <div>
                        <span>{{item.formatted}}</span>
                        <span v-if="item.isRecommended" class="pl-1">(recommended)</span>
                      </div>
                    </template>
                    <template v-slot:selection="{ item }">
                      <span>{{item.from}}-{{item.to}}</span>
                    </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </template>
        <template v-if="this.direction == 2 || this.direction == 3">
          <!-- From Airport or Return / Drop off / Arriving Flight -->
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <validation-provider
                    name="Arrival date"
                    :rules="'required'"
                    v-slot="{errors}" slim>
                    <v-text-field
                      :class="'arrival-date'"
                      v-model="fmtDropOffDetailsTravelDate"
                      label="Arrival date"
                      prepend-icon="mdi-calendar"
                      readonly
                      :hint="arrivalDateHint"
                      persistent-hint
                      :error-messages="errors"
                      v-on="on">
                    </v-text-field>
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="dropOffDetailsTravelDate"
                  @input="menu2 = false"
                  :min="getMinimumbookingDate()"
                  :allowed-dates="enableBookingDate">
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="IS_ADMINISTRATOR ? '6' : '12'">
              <ValidationProvider
                :rules="`${!noFlightArrivalPickupTime ? 'required' : ''}`"
                name="Arriving flight"
                v-slot="{ errors }">
                <v-autocomplete
                  v-model="dropOffDetailsArrivingFlight"
                  :items="CONFIGURATION.arrivingFlights"
                  :hint="ARRIVING_FLIGHT_HINT_TEXT"
                  persistent-hint
                  @change="onArrivingFlightChanged"
                  item-text="number"
                  item-value="id"
                  cache-items
                  flat
                  clearable
                  :error-messages="errors"
                  label="Arriving flight">
                  <template v-slot:item="data">
                    {{ data.item.number }} -
                    {{ $moment(data.item.time, "HH:mm:ss").format(DISPLAY_TIME_FORMAT) }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
            <template v-if="IS_ADMINISTRATOR">
              <v-col cols="2" class="d-flex align-center justify-center">
                <p>Or (no flight)</p>
              </v-col>
              <v-col cols="4">
                <v-select
                  id="noFlightPickupTime"
                  :items="ALL_PICKUP_TIMES"
                  item-text="formatted"
                  item-value="from"
                  v-model="noFlightArrivalPickupTime"
                  label="Pick-up time"
                  required>
                  <template v-slot:selection="{ item }">
                    <span>{{item.from}}-{{item.to}}</span>
                  </template>
                </v-select>
              </v-col>
            </template>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Vue from 'vue';

import { mapGetters, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { ValidationProvider } from 'vee-validate';
import storeConstants from '@/store/storeConstants';
import Flight from '@/components/Flight.vue';

export default {
  name: 'PickupDropOff',
  components: {
    ValidationProvider,
    'add-flight': Flight,
  },
  props: {
    bus: Vue,
  },
  data: () => ({
    addFlightDialog: false,
    limitToCountries: ['AU'],
    menu2: false,
    menu1: false,
    addressValid: false,
    epochMinDate: '2021-01-01T00:00:00',
    googleAutocomplete: 'vuetify-google-autocomplete',
    arrivalDateHint: 'Please enter the date you arrive in '
    + 'Sydney not your date of departure from your country of origin.',
  }),
  created() {
    this.bus.$on(storeConstants.EVT_EXCLUSIVE_CHARTER_CHANGED, () => {
      if (this.formattedAddress) {
        // check if the suburb is a valid if not error.
        this.getSuburb();
        this.CHECK_AND_CALCULATE_FARE();
      }
    });

    this.bus.$on(storeConstants.EVT_GET_BOOKING_COMPLETE, () => {
      if (this.pickUpDetailsDepartingFlight) {
        const pickupTimesPayload = { id: this.pickUpDetailsDepartingFlight, suburb: this.suburb };
        this.GET_PICKUP_TIMES(pickupTimesPayload);
      }
      this.addressValid = true;
      this.otherAddresses.forEach((address, idx) => {
        this.otherAddresses[idx].isValid = true;
      });
    });
  },
  watch: {
    addFlightDialog: {
      handler(val, oldVal) {
        if (val === false && oldVal === true) {
          // fetch new flights when the modal is closed.
          this.getFlights(this.direction === 3);
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      storeConstants.CHECK_AND_CALCULATE_FARE,
      storeConstants.GET_FLIGHTS,
      storeConstants.GET_FLIGHT_DETAILS,
      storeConstants.GET_PICKUP_TIMES,
      storeConstants.GET_PICKUP_TIMES,
      storeConstants.GET_SUBURB,
      storeConstants.GET_OTHER_ADDRESS_SUBURB,
      storeConstants.SET_ALERT_DETAILS,
      storeConstants.RESET_SELECTED_ADDRESS]),
    getMinimumbookingDate() {
      if (!this.minimumBookingDate) {
        return this.$moment(this.epochMinDate).format(this.ISO_8601_FORMAT);
      }
      return this.$moment(this.minimumBookingDate).format(this.ISO_8601_FORMAT);
    },
    enableBookingDate(val) {
      if (this.IS_ADMINISTRATOR) return true;
      const dateEqual = element => this.$moment(element).format(this.ISO_8601_FORMAT)
        === this.$moment(val).format(this.ISO_8601_FORMAT);

      return !this.invalidDates.some(dateEqual);
    },
    callOffice() {
      window.location = 'tel:02 9997 7767';
    },
    clearAddress() {
      this.$refs.addressAutocomplete.clear();
      this.addressValid = false;
      this.RESET_SELECTED_ADDRESS();
    },
    clearOtherAddress(idx) {
      this.otherAddresses.splice(idx, 1);
    },
    onDepartingFlightChanged(e) {
      const payload = { id: e, suburb: this.suburb, isDeparting: true };
      this.GET_FLIGHT_DETAILS(payload)
        .then((flight) => {
          this.$store.commit(storeConstants.SET_DEPARTING_FLIGHT, flight);
          const pickupTimesPayload = { id: e, suburb: this.suburb };
          this.GET_PICKUP_TIMES(pickupTimesPayload)
            .then(() => {
              this.setPickupTime();
            });
        });
    },
    onArrivingFlightChanged(e) {
      const payload = { id: e, suburb: this.suburb, isDeparting: false };
      this.GET_FLIGHT_DETAILS(payload)
        .then((flight) => {
          this.$store.commit(storeConstants.SET_ARRIVING_FLIGHT, flight);
        });
    },
    setPickupTime() {
      const recommendedPickupTime = this.PICKUP_TIMES.find(a => a.isRecommended === true);
      if (recommendedPickupTime) {
        this.pickUpDetailsPickupTime = recommendedPickupTime.from;
      }
    },
    getAdditionalAddress(addressData, placeResultData, id) {
      const addressIdx = id.split('_')[1];
      if (addressIdx === undefined) return;

      const currentItem = this.otherAddresses[addressIdx];
      if (currentItem === undefined) return;

      if (placeResultData.address_components) {
        placeResultData.address_components.forEach((place) => {
          if (place.types) {
            place.types.forEach((type) => {
              if (type === 'subpremise') {
                currentItem.subPremise = place.long_name;
              }
            });
          }
        });
      }

      currentItem.streetNumber = addressData.street_number;
      currentItem.street = addressData.route;
      currentItem.suburb = addressData.locality;
      currentItem.state = addressData.administrative_area_level_1;
      currentItem.postCode = addressData.postal_code;
      currentItem.country = addressData.country;
      currentItem.latitude = addressData.latitude;
      currentItem.longitude = addressData.longitude;
      currentItem.formattedAddress = placeResultData.formatted_address;
      currentItem.place = placeResultData;

      // check if the suburb is a valid if not error.
      this.getSuburbForAdditionalAddress(addressIdx);
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData(addressData, placeResultData) {
      // check if subpremise (unit) is part of the address.
      if (placeResultData.address_components) {
        placeResultData.address_components.forEach((place) => {
          if (place.types) {
            place.types.forEach((type) => {
              if (type === 'subpremise') {
                this.subPremise = place.long_name;
              }
            });
          }
        });
      }

      this.streetNumber = addressData.street_number;
      this.street = addressData.route;
      this.suburb = addressData.locality;
      this.state = addressData.administrative_area_level_1;
      this.postCode = addressData.postal_code;
      this.country = addressData.country;
      this.latitude = addressData.latitude;
      this.longitude = addressData.longitude;
      this.formattedAddress = placeResultData.formatted_address;
      this.place = placeResultData;

      // check if the suburb is a valid if not error.
      this.getSuburb();
      this.CHECK_AND_CALCULATE_FARE();
    },
    getSuburbForAdditionalAddress(index) {
      const otherAddress = this.otherAddresses[index];
      this.GET_OTHER_ADDRESS_SUBURB({
        suburb: otherAddress.suburb,
        exclusiveCharter: this.exclusiveCharter,
      })
        .then((response) => {
          otherAddress.isValid = response.isValid;
          this.$forceUpdate();
          return true;
        });
    },
    getSuburb() {
      this.GET_SUBURB({ suburb: this.suburb, exclusiveCharter: this.exclusiveCharter })
        .then((response) => {
          this.addressValid = response.isValid && !!this.streetNumber;

          // default to exclusive only.
          if (response.isExclusiveOnly) {
            this.exclusiveCharter = true;
          }

          this.SET_ALERT_DETAILS({ showAlert: false });
          if (response.isValid === true) {
            this.getFlights(this.direction === 3);
          } else {
            this.SET_ALERT_DETAILS({ alertText: 'The address cannot be serviced.', showAlert: true });
          }
        });
    },
    getFlights(isReturnTrip) {
      const retrieveFlights = (tempDirection) => {
        const payload = { direction: tempDirection, suburb: this.suburb };

        this.GET_FLIGHTS(payload)
          .then((flights) => {
            if (tempDirection === 1) {
              this.$store.commit(storeConstants.SET_DEPARTING_FLIGHTS, flights);
            } else {
              this.$store.commit(storeConstants.SET_ARRIVING_FLIGHTS, flights);
            }
          });
      };
      if (isReturnTrip) {
        retrieveFlights(1);
        retrieveFlights(2);
      } else {
        retrieveFlights(this.direction);
      }
    },
    addAdditionalAddress() {
      this.otherAddresses = this.otherAddresses || [];
      this.otherAddresses.push({});
    },
    autoCompleteProps(index) {
      return { id: `additionalAddress${index}` };
    },
  },
  computed: {
    ...mapGetters([
      storeConstants.BOOKING,
      storeConstants.IS_ADMINISTRATOR,
      storeConstants.CONFIGURATION,
      storeConstants.BOOKING_DATES,
      storeConstants.PICKUP_TIMES,
      storeConstants.SUBURB_EXCLUSIVE_ONLY,
      storeConstants.ALL_PICKUP_TIMES,
      storeConstants.DISPLAY_DATE_FORMAT,
      storeConstants.ISO_8601_FORMAT,
      storeConstants.DISPLAY_TIME_FORMAT,
      storeConstants.DEPARTING_FLIGHT_HINT_TEXT,
      storeConstants.ARRIVING_FLIGHT_HINT_TEXT]),
    ...mapFields([
      'booking.bookingNumber',
      'booking.passengers',
      'booking.exclusiveCharter',
      'booking.direction',
      'booking.otherAddresses',
      'booking.selectedAddress',
      'booking.selectedAddress.subPremise',
      'booking.selectedAddress.streetNumber',
      'booking.selectedAddress.street',
      'booking.selectedAddress.suburb',
      'booking.selectedAddress.state',
      'booking.selectedAddress.country',
      'booking.selectedAddress.postCode',
      'booking.selectedAddress.latitude',
      'booking.selectedAddress.longitude',
      'booking.selectedAddress.formattedAddress',
      'booking.additionalInfoFromAirport',
      'booking.additionalInfoToAirport',
      'bookingDates.minimumBookingDate',
      'bookingDates.invalidDates',
    ]),
    ...mapFields({
      pickUpDetailsTravelDate: 'booking.pickUpDetails.travelDate',
      pickUpDetailsDepartingFlight: 'booking.pickUpDetails.departingFlight',
      pickUpDetailsPickupTime: 'booking.pickUpDetails.pickupTime',
      dropOffDetailsTravelDate: 'booking.dropOffDetails.travelDate',
      dropOffDetailsArrivingFlight: 'booking.dropOffDetails.arrivingFlight',
      noFlightArrivalPickupTime: 'booking.dropOffDetails.noFlightArrivalPickupTime',
    }),
    fmtPickUpDetailsTravelDate() {
      if (!this.pickUpDetailsTravelDate) {
        return null;
      }
      return this.$moment(this.pickUpDetailsTravelDate).format(this.DISPLAY_DATE_FORMAT);
    },
    fmtDropOffDetailsTravelDate() {
      if (!this.dropOffDetailsTravelDate) {
        return null;
      }
      return this.$moment(this.dropOffDetailsTravelDate).format(this.DISPLAY_DATE_FORMAT);
    },
    directionText() {
      if (this.direction === 1) {
        return 'Pick-up details';
      }
      if (this.direction === 2) {
        return 'Drop-off details';
      }
      if (this.direction === 3) {
        return 'Pick-up/Drop-off details';
      }
      return null;
    },
    maxAddresses() {
      if (!this.exclusiveCharter) {
        return 0;
      }
      const result = (this.passengers - 1)
        - (this.BOOKING.otherAddresses ? this.BOOKING.otherAddresses.length : 0);

      return result;
    },
  },
};
</script>
<style scoped>
div.arrival-date {
  .v-messages__message {
  color: red;
 }
}
.v-card__text .row .col {
  padding: 0.5rem;
}

.selected-address >>> .v-input--selection-controls__input {
  display: none;
}
</style>
